<template>
  <transition name="nested">
    <div
      v-if="modelValue"
      class="absolute z-above-header w-100 rounded-xl bg-grey-90 bg-op-90 px-4 pb-6 backdrop-blur-md transition [&.nested-enter-from,&.nested-leave-to]:scale-95 [&.nested-enter-from,&.nested-leave-to]:op-0"
      :style="dropdownStyles"
    >
      <div class="mb-3.5 flex gap-2">
        <h2 class="w-full title-3">
          {{ $t.myAccount }}
        </h2>
        <button :aria-label="$t.close" data-test-id="vf-dialog-close" @click="emit('update:modelValue', false)">
          <vf-icon name="close" size="md" />
        </button>
      </div>
      <account-authentication @resolve="emit('update:modelValue', false)" />
    </div>
  </transition>
</template>

<script lang="ts" setup>
defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()

const dropdownStyles = {
  right: '-3.5rem',
  top: '-20%',
  transitionDuration: '200ms',
  paddingTop: '.875rem',
  boxShadow: '0 0.125rem 0.9375rem 0 rgba(0, 0, 0, 0.15)',
}
</script>
